import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core'
import { ConfirmPasswordTextFieldValidator, PasswordMatch } from './confirm-password-text-field-validator'
import { Validatable } from './validatable'
import { FormValidationService } from './form-validation-service'

@Component({
    selector: 'ConfirmPasswordTextField',
    templateUrl: './html-templates/validated-text-field.component.html'
})
export class ConfirmPasswordTextField extends Validatable<PasswordMatch> {
    @Input() text = ''
    @Input() label = ''
    @Input() id = ''
    @Input() for = ''
    @Input() validationLabel: string
    @Input() type = 'password'
    @Input() helperText = ''
    @Input() maxlength = ''
    @Input() minlength = ''
    @Input() requiredField: boolean = false
    @Output() onValueChange: EventEmitter<string> = new EventEmitter<string>()
    @Output() blur: EventEmitter<string> = new EventEmitter<string>()
    @Input() originalPassword = ''

    validators = [new ConfirmPasswordTextFieldValidator()]

    constructor(formValidationService: FormValidationService) {
        super(formValidationService)
    }

    onBlur() {
        this.blur.emit(this.text)

        this.validate()
    }

    getDescribedBy(): string {
        const baseId = this.id || this.for;
        const parts: string[] = [];
        if (this.requiredField) {
            parts.push(`${baseId}-required`);
        }
        if (this.errorMessages.length) {
            parts.push(`${baseId} - error`);
        }
        return parts.join('');
    }

    getValue(): PasswordMatch {
        return {
            originalPassword: this.originalPassword,
            confirmedPassword: this.text
        }
    }

    getLabel(): string {
        return this.text
    }

    getId() {
        return this.id
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disabled && changes.disabled.currentValue) {
            this.clearValidationErrors()
        }
    }
}
